/* React core */
import { Component, createRef } from "react"

/* 2GIS MapGL loader */
import { load } from "@2gis/mapgl"
/* 2GIS marker clusterer */
import { Clusterer } from "@2gis/mapgl-clusterer"

/* 2GIS API key from env */
import { map2gisKey } from "../../constants/env"

/* Component Map2gis */
class Map2gis extends Component {

    constructor(props) {
        super(props)

        /* Map container ref */
        this.container = createRef()
        /* Map instance */
        this.map = null
        /* Marker clusterer */
        this.clusterer = null
        /* Mounted flag */
        this.alive = true
    }

    componentDidMount = () => {
        load().then((mapgl) => {
            if (!this.alive) {
                return
            }
            this.map = new mapgl.Map(this.container.current, {
                center: [76.889709, 43.238949],
                zoom: 11,
                key: map2gisKey
            })
            this.clusterer = new Clusterer(this.map, { radius: 60 })
            this.clusterer.on("click", (event) => {
                const target = event.target
                if (target && target.type === "marker" && target.data && target.data.userData) {
                    this.props.onSelect(target.data.userData.id)
                }
            })
            this._draw()
        })
    }

    componentDidUpdate = (prev) => {
        if (prev.items !== this.props.items) {
            this._draw()
        }
    }

    componentWillUnmount = () => {
        this.alive = false
        if (this.map) {
            this.map.destroy()
            this.map = null
        }
    }

    /* Draw Map */
    _draw = () => {
        if (!this.clusterer) {
            return
        }

        /* 2GIS coordinates are [lng, lat] */
        const points = (this.props.items || [])
            .filter((item) => item.lat != null && item.lng != null)
            .map((item) => ({ coordinates: [item.lng, item.lat], userData: { id: item.id } }))

        this.clusterer.load(points)

        if (points.length && this.map) {
            const lats = points.map((point) => point.coordinates[1])
            const lngs = points.map((point) => point.coordinates[0])
            this.map.fitBounds({
                southWest: [Math.min(...lngs), Math.min(...lats)],
                northEast: [Math.max(...lngs), Math.max(...lats)]
            }, { padding: { top: 40, right: 40, bottom: 40, left: 40 } })
        }
    }

    render = () => {
        return <div ref={this.container} className="mapview__leaflet" />
    }
}

/* Export */
export default Map2gis
